<button
	[ngClass]="{
		'btn-checkout': !disabled,
		'w-full': true,
		'invalid-btn-express-checkout': disabled,
		'two-texts': hasTwoTexts,
	}"
	type="button"
	[disabled]="(loading$ | async) || disabled"
	(click)="onButtonClick()"
>
	<div class="button-content">
		<div class="left-content">
			<ion-icon *ngIf="icon" [name]="icon" class="button-icon"></ion-icon>
			<span class="title-button">{{ text }}</span>
		</div>

		<span *ngIf="hasTwoTexts" class="title-button">

      <div class="content-right">
        <span class="subtitle">Subtotal:</span> 
        <span>{{ textRight }}</span>
      </div>
    </span>

		<ion-spinner *ngIf="loading$ | async" name="crescent" class="button-spinner"></ion-spinner>
	</div>
</button>
